
// Fonction utilitaire pour créer un hash simple
export const createGuaranteeLastResearchHash = (data: any): string => {
  const str = JSON.stringify(data);
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 33) ^ str.charCodeAt(i);
  }
  return (hash >>> 0).toString(36); // Conversion en positif et base 36
};

